module.exports = __webpack_public_path__ + "img/solution3.52a62f26.jpg";